module.exports = __webpack_public_path__ + "static/img/kcts.a47c3a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kcts.jpg
// module id = xqA+
// module chunks = 0